import {TFunction} from 'i18next'

export const requiredValidator = (t: TFunction) => ({
  required: t('error.required')
})
